export default "__VITE_ASSET__C9NwRmB9__"